export const MOBILE_MAX_WIDTH = 649;
export const TABLET_MIN_WIDTH = 650;
export const DATE_FORMAT = 'MM.DD.YYYY';
export const MAX_AGE_IN_DAYS = 45655;
export const LEAP_YEAR_MAX_AGE_IN_DAYS = 45656;
export const REGENERATE_TOKEN_INTERVAL = 18 * 60 * 1000;
export const IDLE_SESSION_TIMEOUT = 18 * 60 * 1000;
export const IDLE_RETRY_TIMEOUT = 2 * 60 * 1000;
export const NOT_APPLICABLE = 'NOT_APPLICABLE';
export const SUBMITTED_TO_VENDOR = 'SUBMITTED_TO_VENDOR';
export const INVALID_CASE_REFERENCE_NUMBER = 'INVALID_CASE_REFERENCE_NUMBER';
export const NUMBER_OF_FILES_EXCEEDED_FOR_DOC_TYPE = 'NUMBER_OF_FILES_EXCEEDED_FOR_DOC_TYPE';
export const SELFIE_CORRUPT_IMAGE = 'MITEK_ERROR_COMMON';
export const DOCUMENTS = 'DOCUMENTS';
export const FAILURE_STATUS = 'failure';
export const CORRUPT_IMAGE = 'CORRUPT_IMAGE';
export const UK_DRIVING_LICENCE = 'UK driving licence';
export const PASSPORT = 'Passport';
export const NONE_OPTION_SELECTED = 'I don’t have either of these';
//# sourceMappingURL=constants.js.map